/// <amd-module name="Dashboards/WidgetContracts/Internal/ConfigPanelProps" />
import { WidgetTeamContext } from "../WidgetProps";
import { DashboardWidgetProps } from "./DashboardWidgetProps";

// This file contains types used to mediate between a feature page/Dashboard and the Widget ConfigurationHost.
// All Widget-Developer facing contracts reside in dashboards-widget-contracts.

/**
 *  Run-time information for use during Widget Configuration. This is provided by a ConfigHost when the config is rendered.
 */
export interface ConfigPanelParentProps {
    /**  Callback for parent to cancel configuration and revert changes. */
    onDismiss(): void;

    /**  Callback for parent to act on request to save configuration with proposed changes. */
    onSave(widget: DashboardWidgetProps): void;

    /** Callback for parent to re-render a preview */
    onUpdate(widget: DashboardWidgetProps): void;

    /** Allows config to suppress highlighting, to avoid modal UI collisions.  */
    onTogglePreviewHighlighting?(showPreviewHighlighting: boolean): void;
}

export interface ConfigPanelProps {
    /** Properties for rendering when opening the panel. Any changes once the panel is already open are ignored. */
    config: DashboardWidgetProps;
    parentProps: ConfigPanelParentProps;

    /** Page-level props for a page to describe default team a widget should be operating under. Pages are not currently required to honor this property.  */
    teamContext: WidgetTeamContext;

    projectId: string;
}
